import { Routes } from '@angular/router';
import { pacienteGuard } from '../../core/guards/paciente.guard';

export const pacienteRoutes: Routes = [
  {
    path: 'paciente',
    canActivate: [pacienteGuard],
    loadComponent: () => import('./layout/layout.component').then(m => m.PacienteLayoutComponent),
    children: [
      {
        path: 'dashboard',
        loadComponent: () => import('./dashboard/dashboard.component').then(m => m.DashboardComponent)
      },
      {
        path: 'perfil',
        loadComponent: () => import('./perfil/perfil.component').then(m => m.PerfilComponent)
      },
      {
        path: 'pedidos',
        loadComponent: () => import('./pedidos/pedidos.component').then(m => m.PedidosComponent)
      },
      {
        path: 'favoritos',
        loadComponent: () => import('./favoritos/favoritos.component').then(m => m.FavoritosComponent)
      },
      {
        path: 'carrinho',
        loadComponent: () => import('./carrinho/carrinho.component').then(m => m.CarrinhoComponent)
      },
      {
        path: 'notificacoes',
        loadComponent: () => import('./notificacoes/notificacoes.component').then(m => m.PacienteNotificacoesComponent)
      },
      {
        path: 'receituarios',
        loadComponent: () => import('./receituarios/receituarios.component').then(m => m.ReceituariosComponent)
      },
      {
        path: 'exames',
        loadComponent: () => import('./exames/exames.component').then(m => m.ExamesComponent)
      },
      {
        path: 'farmacias',
        loadComponent: () => import('../farmacias/lista/lista.component').then(m => m.ListaComponent)
      },
      {
        path: 'farmacias/:id',
        loadComponent: () => import('../farmacias/detalhes/detalhes.component').then(m => m.DetalhesComponent)
      },
      {
        path: 'medicamentos/busca',
        loadComponent: () => import('../medicamentos/busca/busca.component').then(m => m.BuscaComponent)
      },
      {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full'
      }
    ]
  }
];
